import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import AppContext from './context/AppContext';
import Template from './components/Template';
import { useState } from "react";
import ProductPay from "./pages/ProductPay";
import CallBack from "./pages/CallBack";
import Failure from "./pages/Failure";

function App() {

  const [currentPage, setCurrentPage] = useState("")
  return (
    <Router>
      <AppContext.Provider value={{ currentPage, setCurrentPage }}>
        <Routes>
          <Route path="/failure/:token_brand/:name/:aid/:session_pay" element={<Failure />} />
          <Route path="/callback/:token_brand/:name/:aid/:session_pay" element={<CallBack />} />
          <Route path="/product_pay/:name" element={<ProductPay />} />
          <Route path="/" element={<Template><Home /></Template>} />
        </Routes>
      </AppContext.Provider>
    </Router>
  );
}

export default App;
